import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';

// Gets default value of FocusedViewFilter for selected folder (FocusedViewFilter.Focused for Inbox and FocusedViewFilte.None for all other folders)
export default function getDefaultFocusedViewFilterForSelectedFolder(
    folderId: string
): FocusedViewFilter {
    const distinguishedFolder = folderIdToName(folderId);
    return isFocusedInboxEnabled() && distinguishedFolder === 'inbox' ? 0 : -1;
}
